import React from 'react';
import { IoMdInformationCircleOutline } from "react-icons/io";

const MessageHeadingWithBadge = ({ text, badgeText = "Beta Version", badgeColor = "#d97706", badgeBg = "rgba(245, 158, 11, 0.1)", badgeBorder = "rgba(245, 158, 11, 0.2)" }) => {
    return (
        <div className="d-flex align-items-center gap-2 mb-3 pb-3 border-bottom">
            <h5 className="theme-text-color m-0">{text}</h5>
            <div className="badge d-flex align-items-center gap-1" style={{
                backgroundColor: badgeBg,
                color: badgeColor,
                padding: '5px 10px',
                borderRadius: '12px',
                fontSize: '11px',
                fontWeight: '500',
                border: `1px solid ${badgeBorder}`
            }}>
                <IoMdInformationCircleOutline size={14} />
                {badgeText}
            </div>
        </div>
    );
};

export default MessageHeadingWithBadge;
